import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { EXPOSURE_TYPES_OPTIONS, SEVERITY_OPTIONS } from './FilterOptions';
import { FilterVariantProps } from '@silverfort/sf-components/dist/Dropdown/interfaces';
import { useIspmContext } from '../IspmContext';
import { RISK_CATEGORIES } from '@silverfort-nodelibs/common/utils/insight';

interface Params {
    severitiesFilter?: number[];
    setSeveritiesFilter: Dispatch<SetStateAction<number[] | undefined>>;
    categories?: string[];
    setCategories: Dispatch<SetStateAction<string[] | undefined>>;
}

const useGetFilters = ({ setSeveritiesFilter, severitiesFilter, setCategories, categories }: Params) => {
    const [filters, setFilters] = useState<FilterVariantProps<string | number>[]>();
    const { hasUserConfigureCustomInsight } = useIspmContext();
    
    useEffect(() => {
        const filteredExposuresTypesOptions = hasUserConfigureCustomInsight 
            ? EXPOSURE_TYPES_OPTIONS 
            : EXPOSURE_TYPES_OPTIONS.filter(
                (option) => option.value !== RISK_CATEGORIES.CUSTOM_INSIGHTS.key
            );
        setFilters([
            {
                variant: 'filter',
                items: filteredExposuresTypesOptions,
                menuClassName: 'w-[200px]',
                onChange: setCategories as (val?: (number | string) | (number | string)[]) => void,
                selectedItems: categories,
                title: 'Exposures category',
                multiple: true,
                onRemove: () => setCategories(undefined),
                removable: !!categories?.length,
                searchable: true
            },
            {
                variant: 'filter',
                items: SEVERITY_OPTIONS,
                menuClassName: 'w-[200px]',
                onChange: setSeveritiesFilter as (val?: (number | string) | (number | string)[]) => void,
                selectedItems: severitiesFilter,
                title: 'Severity',
                multiple: true,
                onRemove: () => setSeveritiesFilter(undefined),
                removable: !!severitiesFilter?.length,
                searchable: true
            }
        ]);
    }, [categories, setCategories, setSeveritiesFilter, severitiesFilter]);

    return filters;
};

export default useGetFilters;
